import { Sidebar } from "../sidebar/Sidebar";
import { AppRoutes } from "@/app/routes";
import { ErrorBoundary } from "@/app/shared/error-boundaries";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { toggleSidebar } from "@/store/uiSlice";

import "./MainLayout.css"

export function MainLayout() {
  const dispatch = useAppDispatch();
  const isCollapsed = useAppSelector((s) => s.ui.isSidebarCollapsed);

  return (
    <div className="flex h-screen bg-background overflow-hidden">
      {/* Sidebar scrolls independently */}
      <div className="h-screen overflow-y-auto hover:overflow-y-auto sidebar-scroll">
        <Sidebar
          isCollapsed={isCollapsed}
          onToggleCollapse={() => dispatch(toggleSidebar())}
        />
      </div>

      {/* Main content scrolls independently */}
      <main className="flex-1 h-full overflow-hidden">
        <div className="h-full overflow-y-auto hover:overflow-y-auto main-scroll">
          <ErrorBoundary>
            <AppRoutes />
          </ErrorBoundary>
        </div>
      </main>
    </div>
  );
}